import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomPdfViewerComponent } from './custom-pdf-viewer.component';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PdfModalComponent } from './pdf-modal/pdf-modal.component';

@NgModule({
    declarations: [CustomPdfViewerComponent, PdfModalComponent],
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        NgxExtendedPdfViewerModule,
        HttpClientModule,
        NgxSpinnerModule,
    ],
    exports: [CustomPdfViewerComponent, PdfModalComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomPdfViewerModule {}
